import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@core/services/core/auth/auth.service';
import { OperationRegisterService } from '@core/services/core/operation-register.service';
import { ContactProductId } from '@models/operation-register';
import { BaseService } from '../core/base.service';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  constructor(
    private base: BaseService,
    private http: HttpClient,
    private auth: AuthService,
    private or: OperationRegisterService
  ) { }

  contactForm(body, policy) {
    const url = `${this.base.getPrivateOIMBaseUrl()}/clients/contactForm`;
    const headers = this.base.getPrivateOIMHeaders();
    const params = this.or.getContactUrlQueryParams(policy, ContactProductId.CONTACT);

    return this.http.post(url, body, { ...headers, params });
  }

  supportForm(body, policy, roProductId) {
    const baseUrl = this.auth.getState().isLogged
      ? this.base.getPrivateOIMBaseUrl()
      : `${this.base.getPublicBaseUrl()}/clientsArea`;

    const url = `${baseUrl}/clients/supportForm`;
    const headers = this.auth.getState().isLogged
                    ? this.base.getPrivateOIMHeaders()
                    : this.base.getPublicHeaders();
    const params = this.or.getContactUrlQueryParams(policy, roProductId);

    return this.http.post(url, body, { ...headers, params });
  }

}
